module.exports = __webpack_public_path__ + "img/naturalbeige@2x.b9f4639.webp";